import { ProductType } from '../constants/productTypes';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineState,
} from '../types';

type LightGuardsStatePostProcess = (
  productType: ProductType,
  context: ProductBuilderMachineContext,
  states: ProductBuilderMachineState[],
) => ProductBuilderMachineState[];

export const lightGuardsStatePostProcess: LightGuardsStatePostProcess = (
  productType,
  context,
  states,
) => {
  const {
    custom: { materialType, materialTypeNight, fitting, dayFabricPosition },
  } = context;

  const productTypesAllowed: ProductType[] = [
    'Roller Blind Day/Night Chainless',
    'Roller Blind Day/Night Chain',
    'Roller Blind Single Chain',
    'Roller Blind Single Chainless',
    'Honeycomb Smartfit',
    'Honeycomb Standard Corded',
    'Honeycomb Standard Cordless',
    'Honeycomb Standard Cordloop',
    'Honeycomb Standard Motorised',
    'Honeycomb Day/Night Motorised',
    'Honeycomb Day/Night Corded',
    'Honeycomb Day/Night Cordless',
    'Honeycomb Dual View Corded',
    'Honeycomb Dual View Cordless',
    'Honeycomb Dual View Motorised',
  ];

  if (!productType || !productTypesAllowed.includes(productType)) return states;

  // Make sure it is a Blockout blind and it is a Reveal Fit
  return (typeof materialType !== 'undefined' && materialType !== 'Blockout') ||
    (typeof materialTypeNight !== 'undefined' &&
      materialTypeNight !== 'Blockout') ||
    (typeof dayFabricPosition !== 'undefined' && dayFabricPosition !== 'Top') ||
    (typeof fitting !== 'undefined' && fitting !== 'Reveal Fit')
    ? states.filter(state => state !== 'lightGuards')
    : states;
};
